<template>
    <div class="container">
        <card
            header-text="Importar archivo CSV de moodle"
            class="col-md-8 offset-md-2">
            <div class="card-body card-block">
                <div class="container">
                    <input @change="handleFileChange" type="file"/>
                </div>
                <button class="btn btn-block btn-info mt-5" @click="readFile">Cargar CSV</button>
            </div>
        </card>
    </div>
</template>
<script>
import { cargarCSV } from '../../api/admin'

export default {
  data: function () {
    return {
      availability: {}
    }
  },
  methods: {
    handleFileChange () {
      this.file = event.target.files[0]
    },
    readFile () {
      if (!this.file) {
        alert('No se ha seleccionado un archivo')
        return
      }
      /* return first object in FileList */
      this.$papa.parse(this.file, {
        header: false,
        complete: function (results) {
          this.availability = results.data
          this.availability = this.availability.reduce((a, b, i) => {
            if (i === 0) return []
            return [...a, {
              nombre: b[0],
              correo: b[1],
              estadoInduccion: b[2] === 'Finalizado',
              fechaInduccion: b[3] ? Date.parse(b[3]) : '',
              estadoCartilla: b[4] === 'Finalizado',
              fechaCartilla: b[5] ? Date.parse(b[5]) : '',
              estadoActivismo: b[6] === 'Finalizado',
              fechaActivismo: b[7] ? Date.parse(b[7]) : '',
              estadoEmpleo: b[8] === 'Finalizado',
              fechaEmpleo: b[9] ? Date.parse(b[9]) : '',
              estadoEmprendimiento: b[10] === 'Finalizado',
              fechaEmprendimiento: b[11] ? Date.parse(b[11]) : ''
            }]
          }, [])

          cargarCSV(this.availability)
            .then((res) => {
              if (res.status === 200) {
                alert('Operación exitosa')
              }
              // console.log(res)
            })
            .catch((err) => {
              console.error(err)
            })
        }
      })
    }
  }
}
</script>
